<template>
  <Banner v-if="route.params.category === 'occasion' && user && user.is_staff"
    ><p>
      <a :href="`/wadmin/catalogue/occasion/${occasion.id}/change/`"
        >Edit this occasion</a
      >
    </p></Banner
  >
</template>

<script>
export default {
  name: 'OccasionEditBanner',
  components: {
    Banner: defineAsyncComponent(() => import('@/components/Header/Banner')),
  },
  props: {
    user: {
      type: [Object, Boolean],
      required: true,
    },
    route: {
      type: Object,
      required: true,
    },
    occasion: {
      type: Object,
      required: true,
    },
  },
}
</script>
